<router-outlet></router-outlet>

<!-- <div *ngIf="isDuplicateTab" class="duplicate-tab-warning">
      ⚠️ Duplicate tab is not allowed. Please use the first tab.
</div> -->

<!-- Toast Message -->
<p-toast [position]="toastPosition" [hideTransitionOptions]="'0ms'" key="toastMessage"></p-toast>
